import React from 'react'
import { observer } from 'mobx-react'

import TabStore from 'stores/tab/TabStore'

import Tab from './Tab'

import styles from './tabBar.scss'

interface IProps {}

class TabBar extends React.Component<IProps> {
  render() {
    return (
      <div data-cy="tab-bar" className={styles.container}>
        {TabStore.openTabs.map(t => (
          <Tab key={t.id} id={t.id} />
        ))}
      </div>
    )
  }
}

export default observer(TabBar)
